module.exports = __webpack_public_path__ + "static/throwing-money-03e7c90eabbad7dab3ac449c9ffb947d.webp";